import type { EtaEndpointType } from "../server/api/EtaEndpoint";
import type { CommonSettingsType } from "../../../common-deprecated/settings/fetchCommonSettings";
import { getAPI } from "../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ApiClient } from "../../../common-deprecated/api-clients/ApiClient";

export const etaClient: ApiClient<
    EtaEndpointType,
    {
        commonSettings: CommonSettingsType;
        model: string;
        car: string;
        colour?: string;
        upholstery?: string;
        etaMatchingType?: string;
    }
> = {
    method: "get",
    route: ({ commonSettings, model, car, colour, upholstery, etaMatchingType }) =>
        `${getAPI(commonSettings, "eta")}/${model}/${car}${
            colour ? `/${colour}${upholstery ? `/${upholstery}` : ""}` : ""
        }${etaMatchingType ? `/${etaMatchingType}` : ""}`,
};

export default etaClient;
